import { Component, Element, h, Prop } from '@stencil/core';
import { HTMLStencilElement } from '@stencil/core/internal';
import { SlotChangeObserver } from '@ace/web-components/dist_lib/utils';

@Component({
	tag: 'w2d-live-wins-swiper-section',
	styleUrl: './w2d-live-wins-swiper-section.scss',
	shadow: true,
})
export class W2dLiveWinsSwiperSection {
	@Prop() backgroundColor: string = 'surface-solid--100';
	@Prop() withPaddingTop: boolean = true;
	@Prop() withPaddingBottom: boolean = true;

	@Element() hostElement: HTMLStencilElement;

	private cardElements: Element[] = [];

	private swiperEl;
	private observer: MutationObserver;

	componentDidLoad() {
		this.loadCardItems();
		// @ts-ignore – for some reason TS complains but this is a fully valid approach.
		this.observer = new SlotChangeObserver(this.hostElement, this.loadCardItems.bind(this));
	}

	disconnectedCallback() {
		this.observer.disconnect();
	}

	private loadCardItems = () => {
		const slotContent = this.hostElement.shadowRoot.querySelector('slot');
		this.cardElements = slotContent ? slotContent.assignedElements() : [];

		if (!this.cardElements || !this.cardElements.length) {
			return;
		}

		this.cardElements.forEach(item => {
			item.classList.add('w2d-live-wins-swiper-section__swiper-el');
			setTimeout(() => {
				item.classList.add('w2d-live-wins-swiper-section__swiper-el--visible');
			}, 100);
			this.swiperEl.insertAdjacentElement('afterbegin', item);
		});
	};

	render() {
		return (
			<ace-section class='w2d-live-wins-swiper-section' with-padding-top={this.withPaddingTop} with-padding-bottom={this.withPaddingBottom} background-color={this.backgroundColor}>
				<div class='w2d-live-wins-swiper-section__hidden-content'>
					<slot></slot>
				</div>
				<slot name='title' slot='title'></slot>
				<div class='w2d-live-wins-swiper-section__swiper-wrapper'>
					<ace-swiper ref={el => (this.swiperEl = el)} hide-if-empty={true} custom-gap={'{"mobile":"0.5rem","tablet":"1rem"}'} with-controls={false}></ace-swiper>
				</div>
				<slot name='footer' slot='footer'></slot>
			</ace-section>
		);
	}
}
